"use client"

import { useState, useEffect } from "react"
import Modal from "../modules/Modal/Moadal"
import Button from "../modules/Button/Button"
import Select from "../modules/Select/Select"
import styles from "../../../styles/inventory/AddSupplies.module.css"
import { fetchSupplyTypes, createSupply } from "../../../services/inventory/detail"

const AddSupplies = ({ isOpen, setIsOpen, onSupplyUpdate }) => {
  const [selectedSupplyType, setSelectedSupplyType] = useState("")
  const [selectedSupply, setSelectedSupply] = useState("")
  const [quantity, setQuantity] = useState("")
  const [loading, setLoading] = useState(false)
  const [successModalOpen, setSuccessModalOpen] = useState(false)
  const [tenoviSupplies, setTenoviSupplies] = useState([])
  const [internalSupplies, setInternalSupplies] = useState([])
  const supplyTypeOptions = [
    { value: "tenovi", label: "Tenovi" },
    { value: "internal", label: "Internal" },
  ]
  useEffect(() => {
    const loadSupplies = async () => {
      if (!selectedSupplyType) return
      try {
        const res = await fetchSupplyTypes(selectedSupplyType)
        if (res && res.success) {
          if (selectedSupplyType === "tenovi") setTenoviSupplies(res.data)
          if (selectedSupplyType === "internal") setInternalSupplies(res.data)
        } else {
          console.error("API Error:", res?.error || "Unknown error")
        }
      } catch (error) {
        console.error("Failed to load supplies:", error)
      }
    }
    loadSupplies()
  }, [selectedSupplyType])

  const getSupplyOptions = () => {
    if (selectedSupplyType === "tenovi") return tenoviSupplies
    if (selectedSupplyType === "internal") return internalSupplies
    return []
  }

  const handleSubmit = async () => {
    if (!selectedSupplyType || !selectedSupply || !quantity) {
      alert("Please fill all fields")
      return
    }

    const quantityNum = Number.parseInt(quantity)
    if (quantityNum <= 0) {
      alert("Quantity must be greater than 0")
      return
    }

    setLoading(true)
    try {
      const res = await createSupply({
        supply_type: selectedSupply, // supply id from API
        quantity: quantityNum,
      })

      if (res && res.success) {
        // New supply object (API should return it)
        const newSupply = res.data?.supply

        //  Instantly update list so Apply dropdown refreshes
        if (newSupply) {
          if (selectedSupplyType === "tenovi") {
            setTenoviSupplies((prev) => [...prev, newSupply])
          } else if (selectedSupplyType === "internal") {
            setInternalSupplies((prev) => [...prev, newSupply])
          }
        }

        if (onSupplyUpdate) {
          onSupplyUpdate(newSupply)
        }

        setSuccessModalOpen(true)
      } else {
        console.error("Failed to add supply:", res?.error)
        alert("Failed to add supply")
      }
    } catch (error) {
      console.error("Failed to add supply:", error)
      alert("Failed to add supply")
    } finally {
      setLoading(false)
    }
  }

  const resetForm = () => {
    setSelectedSupplyType("")
    setSelectedSupply("")
    setQuantity("")
  }

  const handleCloseAll = () => {
    resetForm()
    setIsOpen(false)
    setSuccessModalOpen(false)
  }

  const handleAddMore = () => {
    resetForm()
    setSuccessModalOpen(false)
    if (onSupplyUpdate) {
      onSupplyUpdate()
    }
  }

  return (
    <>

      <Modal
        isOpen={isOpen}
        onClose={handleCloseAll}
        title="Add Supplies"
        width="600px"
        height="auto"
        footer={
          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <Button variant="secondary" onClick={handleCloseAll}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit} loading={loading}>
              Add Supply
            </Button>
          </div>
        }
      >
        <div className={styles.add_supplies_content}>
          <div className={styles.form_group}>
            <label className={styles.form_label}>Select Supply Type</label>
            <Select
              options={supplyTypeOptions}
              value={selectedSupplyType}
              width="100%"
              onChange={setSelectedSupplyType}
              placeholder="Select Supply Type"
            />
          </div>
          {selectedSupplyType && (
            <div className={styles.form_group}>
              <label className={styles.form_label}>Select Supply</label>
              <Select
                options={getSupplyOptions().map((supply) => ({
                  value: supply.id,
                  label: supply.name,
                }))}
                value={selectedSupply}
                onChange={setSelectedSupply}
                width="100%"
                placeholder="Select Supply"
              />
            </div>
          )}

          {/* Quantity */}
          {selectedSupply && (
            <div className={styles.form_group}>
              <label className={styles.form_label}>Quantity</label>
              <input
                type="number"
                className={styles.form_input}
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                placeholder="Enter count here"
                min="1"
              />
            </div>
          )}
        </div>
      </Modal>
      <Modal
        isOpen={successModalOpen}
        onClose={handleCloseAll}
        title="Success"
        width="400px"
        height="auto"
        footer={
          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <Button variant="secondary" onClick={handleCloseAll}>
              Close
            </Button>
            <Button variant="primary" onClick={handleAddMore}>
              Add More
            </Button>
          </div>
        }
      >
        <div className={styles.success_message}>
          Supply added successfully!
          <br />
          Do you want to add more supplies?
        </div>
      </Modal>
    </>
  )
}

export default AddSupplies
